import { useRef } from "react";
import { JobDetail } from "../types/jobTypes";
import { useJobFormState } from "./useJobFormState";
import { useJobFormHandlers } from "./useJobFormHandlers";
import { useJobFormClipboard } from "./useJobFormClipboard";
import { useJobFormReset } from "./useJobFormReset";
import { useJobFormData } from "./useJobFormData";

/**
 * Combined hook that orchestrates all job form functionalities
 */
export const useJobForm = (job: JobDetail | undefined, onSave: (updatedJob: any) => Promise<boolean>) => {
  // Get all the state from useJobFormState
  const {
    jobData,
    setJobData,
    isSubmitting,
    setIsSubmitting,
    activeTab,
    setActiveTab,
    selectedLanguages,
    setSelectedLanguages,
    showOtherLanguageField,
    setShowOtherLanguageField,
    jobDataRef,
    showBudgetPerm,
    showBudgetFreelance
  } = useJobFormState(job);

  // Setup handlers
  const {
    handleSelectCompany,
    handleSelectContact,
    handleSkillsKeyDown,
    handleLanguageChange,
    handleEmploymentTypeChange,
    handleTimeCommitmentChange,
    handleInputChange,
    handleSelectChange,
    handleSubmit,
    isEmploymentTypeSelected
  } = useJobFormHandlers(
    jobDataRef,
    setJobData,
    setSelectedLanguages,
    setShowOtherLanguageField,
    selectedLanguages,
    setIsSubmitting,
    onSave
  );

  // Setup clipboard operations
  const { handlePasteFromClipboard } = useJobFormClipboard(jobDataRef, setJobData);

  // Setup form reset
  const { resetForm } = useJobFormReset(
    setJobData,
    jobDataRef,
    setActiveTab,
    setSelectedLanguages,
    setShowOtherLanguageField
  );

  // Keep data synchronized
  useJobFormData(jobData, setSelectedLanguages, setShowOtherLanguageField);

  return {
    // State
    jobData,
    setJobData,
    isSubmitting,
    setIsSubmitting,
    activeTab,
    setActiveTab,
    selectedLanguages,
    showOtherLanguageField,
    showBudgetPerm,
    showBudgetFreelance,
    
    // Handlers
    handleSelectCompany,
    handleSelectContact,
    handleSkillsKeyDown,
    handleLanguageChange,
    handleEmploymentTypeChange,
    handleTimeCommitmentChange,
    handleInputChange,
    handleSelectChange,
    handleSubmit,
    handlePasteFromClipboard,
    isEmploymentTypeSelected,
    resetForm
  };
};
